import { useEffect } from "react";
import { useCountry } from '../contexts/countrycodecontext.js'
import LoadingSpinner from "../helpers/loadingspinner.js";

const Logout = () => {
  const clientID = localStorage.getItem("clientID");
    const clientsCache = localStorage.getItem("clientsCache");
  const { setSelectedCountry, updateCountryCode } = useCountry();

  useEffect(() => {
    // Clear context
    setSelectedCountry(null);
    updateCountryCode(null);

    // Remove all localStorage items except clientID and clientData
    Object.keys(localStorage).forEach(key => {
      if (key !== "clientID" && key !== 'clientData' &&  key !== 'clientsCache' ) {
        localStorage.removeItem(key);
      }
    });

    // Clear session storage
    sessionStorage.clear();

    // Hard redirect to login page after a short delay
    setTimeout(() => {
      window.location.href = `/Login?clientId=${clientID}`;
    }, 100); // small delay to allow context cleanup

  }, []);

  return (
             <div>
              <center>
              <LoadingSpinner />
            </center>
            </div>
  );
};

export default Logout;
